import { render, staticRenderFns } from "./Shipped.vue?vue&type=template&id=3b232039&"
import script from "./Shipped.vue?vue&type=script&lang=js&"
export * from "./Shipped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports